import { AfterViewInit, Component, effect, ElementRef, input, OnDestroy, signal, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'eiq-ellipse-text',
  templateUrl: 'ellipse-text.component.html',
  styleUrl: 'ellipse-text.component.scss'
})
export class EllipseTextComponent implements AfterViewInit, OnDestroy {
  @ViewChild('textElement') textElement: ElementRef;

  text = input('', {
    transform: (value: string) => this.domSanitizer.bypassSecurityTrustHtml(value ?? '')
  });
  singleLine = input<boolean>(false);

  expanded$ = signal<boolean>(false);
  showExpandable$ = signal<boolean>(false);

  private resizeObserver: ResizeObserver;

  constructor(private domSanitizer: DomSanitizer) {
    effect(
      () => {
        if (this.text()) {
          requestAnimationFrame(() => {
            this.checkLineClamp();
          });
        }
      },
      { allowSignalWrites: true }
    );
  }

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        this.checkLineClamp();
      });
    });

    this.resizeObserver.observe(this.textElement.nativeElement);
    this.checkLineClamp();
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  toggle(): void {
    this.expanded$.update((s) => !s);
  }

  private checkLineClamp(): void {
    if (!this.expanded$()) {
      const element = this.textElement.nativeElement;
      const computedStyle = window.getComputedStyle(element);

      if (computedStyle.webkitLineClamp && computedStyle.webkitBoxOrient === 'vertical') {
        // Line clamp is potentially active. Now, we need to check if it's actually truncating content.

        const originalOverflow = computedStyle.overflow;
        element.style.overflow = 'auto'; // Temporarily allow overflow to measure scrollHeight

        const isClamped = element.scrollHeight > element.clientHeight;

        element.style.overflow = originalOverflow; // Restore original overflow

        if (isClamped) {
          this.showExpandable$.set(true);
        } else {
          this.showExpandable$.set(false);
        }
      } else {
        this.showExpandable$.set(false);
      }
    }
  }
}
